<mat-tab-group>
    <mat-tab label="Link Information"> 
    
    </mat-tab>
    <mat-tab label="Manage Pools"> 
        <app-flash-pools-admin></app-flash-pools-admin>
    </mat-tab>
    <mat-tab label="Deactivate">  </mat-tab>
</mat-tab-group>
